// CustomDropdown.js
import React, { useState, useEffect, useRef } from "react";
import "./../../styleSheet/main/reservations/customDropdown/customDropdown.css"; // Import your custom styles
import Logger from "../../utils/Logger";

const CustomDropdown = ({ options, value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggle = () => {
    Logger.log("Dropdown toggled, isOpen:", isOpen);
    setIsOpen(!isOpen);
  };

  const handleSelect = (option) => {
    Logger.log("Option selected:", option);
    setSelectedOption(option);
    onChange(option); // Notify parent of the change
    setIsOpen(false); // Close dropdown after selection
  };

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div
        className={`dropdown-header ${selectedOption ? "selected-header" : ""}`}
        onClick={handleToggle}
      >
        {selectedOption || placeholder}
        <span className="dropdown-arrow">&#9660;</span>
      </div>
      {isOpen && (
        <div className="menu-triangle">
          <div class="triangle-up"></div>
          <div className="dropdown-menu">
            {options.map((option) => (
              <div
                key={option}
                className={`dropdown-item-2 ${
                  selectedOption === option ? "selected" : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                {option}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
